export default __webpack_public_path__ + "static/media/disabled_update_icon.318f8966.svg";